<div class="expired-container">
	<div class="expired-card">
        <h2 class="text-center"> Link Expired</h2>
        <br>
		<div class="font-18 text-break pt-4">{{errorMessage}}</div>
	</div>
</div>
